import React from 'react'
import Skeleton, {SkeletonTheme} from 'react-loading-skeleton'

let AppSkeleton = ({height = 20}) => <SkeletonTheme baseColor="#E3EFFF" highlightColor="#9cc2f5">
    <Skeleton height={height}/>
</SkeletonTheme>

export default AppSkeleton